import React from 'react';
import PropTypes from 'prop-types';
import Assets from '../../../../../requests/apa/Asset';
import MatchDetailLineupsPlayer from '../MatchDetailLineupsPlayer/MatchDetailLineupsPlayer';
import './_MatchDetailLineupsField.scss';

/**
 * MatchDetailLineupsField — Campo de fútbol con jugadores posicionados
 *
 * Large/Canchas/Completa + Large/Jugadores (node 106:11182)
 * El campo se dibuja con CSS puro, sin imágenes externas.
 * Los jugadores se posicionan absolutamente según x%, y% del mock.
 *
 * Conversión px→rem: (px / 1.5) / 10
 * Campo Figma: 1200×592px → 80rem × 39.467rem
 *
 * Sin flex ni grid.
 */

/**
 * Renderiza los jugadores de un equipo sobre el campo.
 * La posición del card se centra en (x%, y%) del campo.
 * Card: 8.6rem × 5.867rem → offset: 4.3rem horizontal, 2.933rem vertical
 */
const TeamPlayers = ({ players, teamColor }) => {
  return (
    <span>
      {players.map(function (player) {
        var left = 'calc(' + player.x + '% - 4.3rem)';
        var top  = 'calc(' + player.y + '% - 2.933rem)';
        return (
          <div
            key={player.id}
            className="lineups-field__player"
            style={{ left: left, top: top }}
          >
            <MatchDetailLineupsPlayer player={player} teamColor={teamColor} />
          </div>
        );
      })}
    </span>
  );
};

const MatchDetailLineupsField = ({ homeTeam, awayTeam }) => {
  const fieldBg = Assets.get('eventodeportivo_alineaciones_cancha');
  const fieldStyle = fieldBg ? { backgroundImage: `url(${fieldBg})`, backgroundSize: 'cover', backgroundPosition: 'center' } : {};

  return (
  <div className="lineups-field" style={fieldStyle}>
    {/* ── Marcas del campo (CSS puro) ── */}

    {/* Área chica izquierda: 32×124px → 2.133rem × 8.267rem */}
    <div className="lineups-field__box lineups-field__box--small-left" />

    {/* Área grande izquierda: 156×348px → 10.4rem × 23.2rem */}
    <div className="lineups-field__box lineups-field__box--large-left" />

    {/* Área chica derecha */}
    <div className="lineups-field__box lineups-field__box--small-right" />

    {/* Área grande derecha */}
    <div className="lineups-field__box lineups-field__box--large-right" />

    {/* Línea central vertical */}
    <div className="lineups-field__center-line" />

    {/* Círculo central */}
    <div className="lineups-field__center-circle" />

    {/* ── Jugadores ── */}
    <TeamPlayers players={homeTeam.starters || []} teamColor={homeTeam.teamColor} />
    <TeamPlayers players={awayTeam.starters || []} teamColor={awayTeam.teamColor} />
  </div>
  );
};

MatchDetailLineupsField.propTypes = {
  homeTeam: PropTypes.shape({
    teamColor: PropTypes.string,
    starters: PropTypes.array.isRequired
  }).isRequired,
  awayTeam: PropTypes.shape({
    teamColor: PropTypes.string,
    starters: PropTypes.array.isRequired
  }).isRequired
};

export default MatchDetailLineupsField;



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/Components/MatchDetailLineupsField/MatchDetailLineupsField.jsx